import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';

import styles from './styles.module.scss';

const Button = ({
	title,
	tooltip,
	icon,
	active,
	theme,
	url,
	type,
	onClick,
	markupAttributes,
	className,
	iconAlign,
	iconClassName,
	tabIndex,
	buttonRef,
	ariaLabel
}) => {
	const Tag = url ? 'a' : 'button';
	const typeButton = !url ? type || 'button' : null;
	const buttonCx = cx(
		styles.button,
		styles[`theme_${theme}`],
		{ [styles.active]: active },
		className
	);
	const iconElement = icon && (
		<Icon
			icon={icon}
			className={cx(
				styles.icon,
				styles[icon],
				styles[iconAlign],
				iconClassName
			)}
		/>
	);

	return (
		<Tag
			className={buttonCx}
			url={url}
			type={typeButton}
			onClick={onClick}
			title={tooltip}
			tabIndex={tabIndex}
			ref={buttonRef}
			aria-label={ariaLabel}
			{...markupAttributes}
		>
			{iconAlign === 'left' && iconElement}
			{title && <span className={styles.text}>{title}</span>}
			{iconAlign === 'right' && iconElement}
		</Tag>
	);
};

Button.propTypes = {
	title: PropTypes.string,
	tooltip: PropTypes.string,
	icon: PropTypes.string,
	url: PropTypes.string,
	active: PropTypes.bool,
	type: PropTypes.oneOf(['button', 'submit']),
	theme: PropTypes.oneOf([
		'outline',
		'onlyIcon',
		'form',
		'primary',
		'dark',
		'callToAction',
		'simple'
	]),
	onClick: PropTypes.func,
	markupAttributes: PropTypes.object,
	className: PropTypes.string,
	iconClassName: PropTypes.string,
	iconAlign: PropTypes.oneOf(['left', 'right']),
	tabIndex: PropTypes.number,
	buttonRef: PropTypes.object,
	ariaLabel: PropTypes.string
};

Button.defaultProps = {
	active: false,
	iconAlign: 'left'
};

export default Button;
